import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const nav = useNavigate();

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo!");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao fazer login");
    } finally { setLoadingBtn(false); }
  };

  return (
    <div className="min-h-screen bg-[#000000] flex items-center justify-center px-4 relative">
      <div className="ambient-bg" />
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-10">
          <Logo size="lg" onClick={() => nav("/")} />
        </div>
        <form onSubmit={submit} className="ci-card p-8 space-y-5" data-testid="admin-login-form">
          <div className="text-center">
            <div className="label">Área Administrativa</div>
            <h1 className="font-display text-3xl font-bold mt-2">Entrar</h1>
          </div>
          <div>
            <label className="label block mb-2">E-mail</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="ci-input pl-10" />
            </div>
          </div>
          <div>
            <label className="label block mb-2">Senha</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="ci-input pl-10" />
            </div>
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loadingBtn} className="btn-primary w-full disabled:opacity-50">
            {loadingBtn ? "Entrando..." : "Entrar"}
          </button>
          <Link to="/" className="text-xs text-slate-500 hover:text-blue-400 text-center block">← Voltar ao site</Link>
        </form>
      </div>
    </div>
  );
}
